<nav class="workspace-breadcrumb" *ngIf="breadcrumbs.length" [attr.aria-label]="label">
  <ng-container *ngFor="let crumb of breadcrumbs; let last = last; trackBy: trackPosition">
    <a [routerLink]="crumb.path" [queryParams]="crumb.queryParams ?? null">{{ crumb.label }}</a>
    <span *ngIf="!last || trailingSeparator" class="workspace-breadcrumb__separator">/</span>
  </ng-container>
</nav>
